export default {
  mounted() {
    const inputs = this.el.querySelectorAll("input[type=text]")

    inputs[0].focus();

    for (elem of inputs) {
      elem.addEventListener('input', (event) => {
        const value = event.value;
        // This doesn't work because our inputs are wrapped in divs and labels
        const nextElement = this.next(event.target);

        if (value === '' || !nextElement) {
          return;
        }
        nextElement.focus();
      });
    }

    for (let elem of inputs) {
      elem.addEventListener('paste', (event) => {
        event.preventDefault();
        let paste = (event.clipboardData || window.clipboardData).getData("text");

        if (paste.length === 6) {
          for (let index = 0; index < paste.length; index++) {
            const item = paste[index];
            inputs[index].value = item
            inputs[index].focus()
          }
        }
      })
      elem.addEventListener('keydown', (event) => {
        // Right Arrow Key
        if (event.keyCode == 39) {
          this.next(event.target)?.focus();
        }

        // Left Arrow Key
        // Add Highlight
        if (event.keyCode == 37) {
          this.previous(event.target)?.focus();
        }

        // Backspace Key
        if (event.keyCode == 8 && event.metaKey) {
          for (innerElem of inputs) {
            innerElem.value = '';
          }
          inputs[0].focus();
        } else if (event.keyCode == 8) {
          event.preventDefault()
          event.target.value = '';
          this.previous(event.target)?.focus();
          return;
        }
      });
    }

  },

  next(target) {
    switch (target.id) {
      case 'verification_one':
        return this.el.querySelector("input#verification_two");
      case 'verification_two':
        return this.el.querySelector("input#verification_three");
      case 'verification_three':
        return this.el.querySelector("input#verification_four");
      case 'verification_four':
        return this.el.querySelector("input#verification_five");
      case 'verification_five':
        return this.el.querySelector("input#verification_six");
      default:
        return;
    }
  },
  previous(target) {
    switch (target.id) {
      case 'verification_six':
        return this.el.querySelector("input#verification_five");
      case 'verification_five':
        return this.el.querySelector("input#verification_four");
      case 'verification_four':
        return this.el.querySelector("input#verification_three");
      case 'verification_three':
        return this.el.querySelector("input#verification_two");
      case 'verification_two':
        return this.el.querySelector("input#verification_one");
      default:
        return;
    }
  }
}
